import { useApolloClient } from '@apollo/client'
import { useGraphqlFetchAndCacheWithKey } from '@mostrans/web-components/hooks/useGraphqlFetchAndCacheWithKey'
import { DetailOpportunityAtom } from '../OpportunityAtoms'
import { getOpportunityByID } from '../OpportunityQueries'

export const useGetdetailOpportunity = (oppId) => {
    const client = useApolloClient()
    return useGraphqlFetchAndCacheWithKey({
        atom: DetailOpportunityAtom,
        variables: oppId,
        initialValue: null,
        getData: (getOpportunityByIdId) => getOpportunityByID(client, {
            getOpportunityByIdId
        })
    })
}
